module.exports = __webpack_public_path__ + "img/jiQiRen1.2801f6e2.png";